import { Info } from 'lucide-react';
import { useId, type ReactNode } from 'react';
import { Tooltip, cn } from '@/components/ui';

/**
 * Small info button with an explanatory tooltip. The explanation is also the
 * button's accessible description, so it is never tooltip-only.
 */
export const HelpTip = ({
  label,
  children,
  className,
}: {
  /** Accessible name, e.g. "Explain RMS". */
  label: string;
  children: ReactNode;
  className?: string;
}) => {
  const id = useId();
  return (
    <>
      <Tooltip content={children}>
        <button
          type="button"
          aria-label={label}
          aria-describedby={id}
          className={cn(
            'inline-flex size-5 shrink-0 items-center justify-center rounded-full align-middle text-fg-muted transition-colors hover:text-fg',
            className
          )}
        >
          <Info aria-hidden="true" className="size-3.5" />
        </button>
      </Tooltip>
      <span id={id} className="sr-only">
        {children}
      </span>
    </>
  );
};
